import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { ResourcePool } from "../types/castle";

export interface PackageContents {
  resources: ResourcePool;
  inventoryItems?: Record<string, number> | null;
  soulShards: number;
  heroXp: number;
}

export interface PackageDef {
  id: string;
  title: string;
  description: string;
  starsPrice: number;
  highlight?: string | null;
  contents: PackageContents;
}

export function usePackages() {
  return useQuery({
    queryKey: ["packages"],
    queryFn: async () => {
      const res = await api.get<PackageDef[]>("/payments/packages");
      return res.data;
    },
    staleTime: 60_000,
  });
}

export interface InvoiceResponse {
  invoiceUrl: string;
  packageId: string;
  starsPrice: number;
  payload: string;
}

// Calls server to create a Telegram Stars invoice link for the given
// package. Webapp then opens this link with WebApp.openInvoice and
// Telegram handles the rest of the payment flow.
export function useCreateInvoice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (packageId: string) => {
      const res = await api.post<InvoiceResponse>("/payments/invoice", { packageId });
      return res.data;
    },
    onSuccess: () => {
      // Castle state will update via the bot's fulfilment call once
      // the payment goes through — we don't pre-invalidate here.
      qc.invalidateQueries({ queryKey: ["castle"] });
    },
  });
}
